import { Form, FormInput } from 'metrix-common3';
// biome-ignore lint/correctness/noUnusedImports: This import is necessary for the component to function correctly
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileSupernovaCommercialEmployment = ({
    pageCode,
    doUpsertPolicy,
    doGetPolicy,
    allowEdit,
    policy,
    doReducePolicyElement,
    tooltipInfo,
    validationInfo,
    doUpsertTooltipInfo,
    doReduceTooltipInfoElement,
}) => (
    <>
        <Form
            pageCode={pageCode}
            sectionCode='employmentInformation'
            header={<FormattedMessage id='Profile_SupernovaCommercial_Employment.header' defaultMessage='Employment' />}
            label={
                <FormattedMessage
                    id='Profile_SupernovaCommercial_Employment.employmentInformation'
                    defaultMessage='Employment Information'
                />
            }
            tooltipInfo={tooltipInfo}
            validationInfo={validationInfo}
            saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
            reduceTooltipInfoElement={doReduceTooltipInfoElement}
            saveEvent={doUpsertPolicy}
            cancelEvent={doGetPolicy}
            allowEdit={allowEdit}
        >
            <FormInput
                fieldCode='snCommercialEmploymentInfo.jobTitle'
                label={
                    <FormattedMessage id='Profile_SupernovaCommercial_Employment.jobTitle' defaultMessage='Job Title' />
                }
                value={policy?.employmentInfo?.jobTitle}
                type='text'
                changeEvent={(value) =>
                    doReducePolicyElement({
                        code: 'employmentInfo.jobTitle',
                        value,
                    })
                }
                allowEdit
            />
        </Form>
    </>
);

export default ProfileSupernovaCommercialEmployment;
